export default {
  async subscribe({ commit, getters }, namespace) {
    if (getters.namespaces.includes(namespace)) return true

    const resp = await this.$api.app.subscribe(namespace)
    commit('addNamespace', namespace)

    return resp
  },
  async unsubscribe({ commit }, namespace) {
    const resp = await this.$api.app.unsubscribe(namespace)
    commit('removeNamespace', namespace)
    return resp
  },
}
